export default class VehicleClosest {
    constructor() {
            this.hasError = false;
            this.errorMessage = "";
            return this;
    }
    isObjectNear(x_min, y_min, x_max, y_max, image_width, image_height) {
        const bbox_width = x_max - x_min;
        const bbox_height = y_max - y_min;
        const bbox_area = bbox_width * bbox_height;
        const image_area = image_width * image_height;
        const ratio = bbox_area / image_area;
        return ratio; 
    }

    isClose(box,image_width,image_height,threshold){
        const [x1,y1,x2,y2] = box;
        const finded_ratio = this.isObjectNear(x1,y1,x2,y2,image_width,image_height);
        return [finded_ratio > threshold,finded_ratio];
    }
}